import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { FREQUENCIES, WEEKDAYS } from "./contractUtils";

import DateInput from "../DateInput";
/** Frequency / weekdays / dates / times block. `form` + `set(patch)`. */
export function ContractScheduleFields({ form, set }) {
  const needsWeekdays = ["daily", "weekly", "fortnightly"].includes(form.frequency);
  const toggleDay = (i) => set({ weekdays: form.weekdays.includes(i) ? form.weekdays.filter((d) => d !== i) : [...form.weekdays, i].sort() });
  return (
    <div className="space-y-3" data-testid="contract-schedule-fields">
      <div>
        <Label className="text-xs">Frequency</Label>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-1.5 mt-1">
          {FREQUENCIES.map((f) => (
            <button key={f.value} type="button" onClick={() => set({ frequency: f.value, weekdays: f.value === "daily" && !form.weekdays.length ? [0, 1, 2, 3, 4] : form.weekdays })}
              className={`rounded-md border px-2 py-1.5 text-left transition ${form.frequency === f.value ? "border-primary bg-primary/10" : "border-border hover:bg-muted/40"}`} data-testid={`contract-freq-${f.value}`}>
              <p className="text-xs font-semibold">{f.label}</p>
              <p className="text-[10px] text-muted-foreground leading-tight">{f.hint}</p>
            </button>
          ))}
        </div>
      </div>
      {needsWeekdays && (
        <div>
          <Label className="text-xs">Visit days</Label>
          <div className="flex flex-wrap gap-1.5 mt-1">
            {WEEKDAYS.map((d, i) => (
              <button key={d} type="button" onClick={() => toggleDay(i)} className={`h-8 w-11 rounded-full text-xs font-medium border transition ${form.weekdays.includes(i) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted/40"}`} data-testid={`contract-day-${i}`}>{d}</button>
            ))}
            <button type="button" onClick={() => set({ weekdays: [0, 1, 2, 3, 4] })} className="text-[11px] text-primary hover:underline ml-1">Mon–Fri</button>
            <button type="button" onClick={() => set({ weekdays: [0, 1, 2, 3, 4, 5, 6] })} className="text-[11px] text-primary hover:underline">Every day</button>
          </div>
        </div>
      )}
      {form.frequency === "monthly" && (
        <div className="w-40"><Label className="text-xs">Day of month</Label><Input type="number" min={1} max={31} value={form.month_day} onChange={(e) => set({ month_day: e.target.value })} data-testid="contract-month-day" /></div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div><Label className="text-xs">Start date *</Label><DateInput value={form.start_date} onChange={(e) => set({ start_date: e.target.value })} data-testid="contract-start-date" /></div>
        <div><Label className="text-xs">End date <span className="text-muted-foreground">(blank = open-ended)</span></Label><DateInput value={form.end_date} onChange={(e) => set({ end_date: e.target.value })} data-testid="contract-end-date" /></div>
        <div><Label className="text-xs">Arrive</Label><Input type="time" value={form.start_time} onChange={(e) => set({ start_time: e.target.value })} data-testid="contract-start-time" /></div>
        <div><Label className="text-xs">Finish</Label><Input type="time" value={form.end_time} onChange={(e) => set({ end_time: e.target.value })} data-testid="contract-end-time" /></div>
      </div>
      {!form.end_date && form.frequency !== "adhoc" && <p className="text-[11px] text-muted-foreground">Open-ended: visits are kept booked 90 days ahead automatically.</p>}
    </div>
  );
}
